import { useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';
import IconContainer from '../../../common-components/FtuxComponent/IconContainer';
import graphSkeleton1 from '../../../../images/discovery/demographics/graph-skeleton1.svg';
import graphSkeleton2 from '../../../../images/discovery/demographics/graph-skeleton2.svg';
import SaralLoader from '../../../../images/saral-loader.gif';

const texts = [
  'Peeking into their demographics and compiling...',
  "Please wait, we're gathering your data faster than a cheetah on a caffeine high",
  'You can come back later if this is taking too much time. Check notifications on the top right after a couple of minutes.',
  'Bending the limits of the space-time continuum',
  "Calculating the meaning of life, the universe, and everything... just kidding, it's only demographics...",
  'You can come back later if this is taking too much time. Check notifications on the top right after a couple of minutes.',
  'Sit back, relax, and let our team of highly caffeinated statisticians do the work.',
  'Please be patient while we transform your data into something even a unicorn would envy.',
  'You can come back later if this is taking too much time. Check notifications on the top right after a couple of minutes.',
  'Hacking into Instagram... ',
  "Don't think of purple cows...",
  'Doing the heavy lifting...',
  'Glad I paid attention in math class...',
  "Are you still waiting? You can keep browsing and come back after a minute. We'll keep this ready",
];

export default function LoadingComponents() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalFunc = () => {
      setCurrentIndex((prev) => prev + 1);
    };
    setInterval(intervalFunc, 3000);
    return () => clearInterval(intervalFunc);
  }, []);

  return (
    <div className="demographics-loader">
      {currentIndex <= texts.length && (
        <div id="demographics">
          <div className="demographics-row">
            <Card1 />
            <Card2 />
          </div>
          <Skeleton
            variant="rounded"
            sx={{ borderRadius: 40, marginTop: '32px', marginBottom: '4px' }}
            width={'100px'}
            height={24}
          />
          <div className="demographics-row">
            <Card3 />
            <Card4 />
          </div>
          <div className="demographics-row">
            <Card5 />
            <Card5 />
          </div>
        </div>
      )}
      <div className="loading-text">
        {currentIndex <= texts.length ? (
          <img src={SaralLoader} alt="loader" width={80.5} />
        ) : (
          <center>
            <IconContainer icon="📊" />
          </center>
        )}
        <p>
          {currentIndex >= texts.length
            ? texts[texts.length - 1]
            : texts[currentIndex]}
        </p>
      </div>
    </div>
  );
}

const Card1 = () => {
  return (
    <div className="demographics-card">
      <Skeleton
        variant="circular"
        sx={{ marginBottom: '12px' }}
        width={48}
        height={48}
      />
      <Skeleton
        variant="rounded"
        sx={{ borderRadius: 40, marginBottom: '4px' }}
        width={'20%'}
        height={24}
      />
      <Skeleton
        variant="rounded"
        sx={{ borderRadius: 40, marginBottom: '12px' }}
        width={'30%'}
        height={24}
      />
      <Skeleton
        variant="rounded"
        sx={{ borderRadius: 40, marginBottom: '4px' }}
        width={'10%'}
        height={20}
      />
      <Skeleton
        variant="rounded"
        sx={{ borderRadius: 40, marginBottom: '4px' }}
        width={'80%'}
        height={18}
      />
      <Skeleton
        variant="rounded"
        sx={{ borderRadius: 40, marginBottom: '4px' }}
        width={'100%'}
        height={18}
      />
      <Skeleton
        variant="rounded"
        sx={{ borderRadius: 40 }}
        width={'100%'}
        height={18}
      />
    </div>
  );
};

const Card2 = () => {
  return (
    <div className="profile-stats-container">
      {[1, 2, 3].map((d1) => (
        <div className="profile-stats-row" key={d1}>
          {[1, 2, 3, 4].map((d2) => (
            <div className="detail-card" style={{ minHeight: 70 }} key={d2} />
          ))}
        </div>
      ))}
    </div>
  );
};

const Card3 = () => {
  return (
    <div className="demographics-card">
      <Skeleton
        variant="rounded"
        sx={{ borderRadius: 40, marginBottom: '24px' }}
        width={'20%'}
        height={24}
      />
      <img
        src={graphSkeleton1}
        alt="skeleton"
        style={{ width: '85%', marginLeft: '30px' }}
      />
    </div>
  );
};

const Card4 = () => {
  return (
    <div className="demographics-card">
      <Skeleton
        variant="rounded"
        sx={{ borderRadius: 40, marginBottom: '24px' }}
        width={'20%'}
        height={24}
      />
      <img src={graphSkeleton2} alt="skeleton" style={{ width: '90%' }} />
    </div>
  );
};

const Card5 = () => {
  return (
    <div className="demographics-card">
      <Skeleton
        variant="rounded"
        sx={{ borderRadius: 40, marginBottom: '4px' }}
        width={'20%'}
        height={24}
      />
      <div className="tags-container">
        {['20%', '40%', '30%', '25%', '50%', '30%', '25%'].map(
          (width, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              sx={{ borderRadius: 40 }}
              width={width}
              height={35}
            />
          ),
        )}
      </div>
    </div>
  );
};
